"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MfaSection = void 0;

var _react = _interopRequireWildcard(require("react"));

var _MfaTypeChamp = require("../commun/MfaTypeChamp");

var _utilitaires = require("../utils/utilitaires");

var _MfaAireTexte = require("./MfaAireTexte");

var _MfaEnveloppe = require("./MfaEnveloppe");

var _MfaListeDeroulante = require("./MfaListeDeroulante");

var _MfaRadioBoutons = require("./MfaRadioBoutons");

var _MfaSelecteurDate = require("./MfaSelecteurDate");

var _MfaSeparateur = require("./MfaSeparateur");

var _MfaTexte = require("./MfaTexte");

require("../css/mfa-section.css");

var _semanticUiReact = require("semantic-ui-react");

var _MfaCaseACocher = require("./MfaCaseACocher");

var _MfaCommentaire = require("./MfaCommentaire");

var _MfaTexteRadioBoutonHorizon = require("./MfaTexteRadioBoutonHorizon");

var _MfaTexteMasque = require("./MfaTexteMasque");

var _MfaFormulaireNavigationCommentaire = require("./formulaire/MfaFormulaireNavigationCommentaire");

var _MfaBlocPersonalise = require("./MfaBlocPersonalise");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var MfaSection = /*#__PURE__*/function (_Component) {
  _inherits(MfaSection, _Component);

  var _super = _createSuper(MfaSection);

  function MfaSection(props) {
    var _this;

    _classCallCheck(this, MfaSection);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "champs", {});

    _this.state = {
      cache: !!_this.props.cacheInitial
    };
    return _this;
  }

  _createClass(MfaSection, [{
    key: "obtenirDictionnaireChamp",
    value: function obtenirDictionnaireChamp() {
      if (!MfaSection.dictionnaireChamp) {
        var dictionnaire = {};
        dictionnaire[_MfaTypeChamp.MfaTypeChamp.texte] = _MfaTexte.MfaTexte;
        dictionnaire[_MfaTypeChamp.MfaTypeChamp.liste] = _MfaListeDeroulante.MfaListeDeroulante;
        dictionnaire[_MfaTypeChamp.MfaTypeChamp.aire] = _MfaAireTexte.MfaAireTexte;
        dictionnaire[_MfaTypeChamp.MfaTypeChamp.date] = _MfaSelecteurDate.MfaSelecteurDate;
        dictionnaire[_MfaTypeChamp.MfaTypeChamp.radio] = _MfaRadioBoutons.MfaRadioBoutons;
        dictionnaire[_MfaTypeChamp.MfaTypeChamp.case] = _MfaCaseACocher.MfaCaseACocher;
        dictionnaire[_MfaTypeChamp.MfaTypeChamp.commentaire] = _MfaCommentaire.MfaCommentaire;
        dictionnaire[_MfaTypeChamp.MfaTypeChamp.radioTexteHorizontal] = _MfaTexteRadioBoutonHorizon.MfaTexteRadioBoutonHorizon;
        dictionnaire[_MfaTypeChamp.MfaTypeChamp.texteMasque] = _MfaTexteMasque.MfaTexteMasque;
        dictionnaire[_MfaTypeChamp.MfaTypeChamp.navigationCommentaire] = _MfaFormulaireNavigationCommentaire.MfaFormulaireNavigationCommentaire;
        dictionnaire[_MfaTypeChamp.MfaTypeChamp.blocPersonalise] = _MfaBlocPersonalise.MfaBlocPersonalise;
        MfaSection.dictionnaireChamp = dictionnaire;
      }

      return MfaSection.dictionnaireChamp;
    }
  }, {
    key: "enregistrerChamps",
    value: function enregistrerChamps(nom, ref) {
      if (!(0, _utilitaires.estDefini)(ref)) {
        return;
      }

      this.champs[(0, _utilitaires.estDefini)(nom) ? nom : (0, _utilitaires.guid)()] = ref;
    }
  }, {
    key: "obtenirChamp",
    value: function obtenirChamp(champ) {
      var _this2 = this;

      var dictionnaire = this.obtenirDictionnaireChamp();
      var cle = "champ-".concat(champ.etiquette || (0, _utilitaires.guid)());

      if (!(0, _utilitaires.estDefini)(champ.type)) {
        return /*#__PURE__*/_react.default.createElement("div", {
          key: cle,
          className: "mfa-section-champ"
        }, /*#__PURE__*/_react.default.createElement(_MfaEnveloppe.MfaEnveloppe, _extends({
          etiquette: champ.etiquette,
          taille: champ.taille || 'lg'
        }, champ.proprietes), (0, _utilitaires.estDefini)(champ.valeur) ? champ.valeur.toString() : null));
      }

      var ComposanteSurMesure = champ.composante;

      if ((0, _utilitaires.estDefini)(ComposanteSurMesure)) {
        return /*#__PURE__*/_react.default.createElement("div", {
          key: cle,
          className: "mfa-section-champ"
        }, ComposanteSurMesure);
      }

      var Composante = dictionnaire[champ.type];

      if (!Composante) {
        return null;
      }

      var proprietesChamp = {};
      var proprietes = champ.proprietes,
          classeChamp = champ.classeChamp;

      if ((0, _utilitaires.estDefini)(proprietes)) {
        Object.assign(proprietesChamp, proprietes);
      }

      var restant = (0, _utilitaires.filtrerProprietesObjet)(champ, 'proprietes', 'type', 'codeApp', 'classeChamp');
      Object.assign(proprietesChamp, restant);
      return proprietesChamp.estVisible !== false ? /*#__PURE__*/_react.default.createElement("div", {
        key: cle,
        className: "mfa-section-champ".concat((0, _utilitaires.estDefini)(classeChamp) ? " ".concat(classeChamp) : '')
      }, /*#__PURE__*/_react.default.createElement(Composante, _extends({
        ref: function ref(_ref) {
          return _this2.enregistrerChamps(proprietesChamp.nom, _ref);
        }
      }, proprietesChamp))) : null;
    }
  }, {
    key: "renderCorps",
    value: function renderCorps() {
      var _this3 = this;

      var champs = this.props.champs;

      if (!champs) {
        return null;
      }

      var nombreParColonne = this.props.nombreParColonne;

      if (!nombreParColonne) {
        nombreParColonne = [2];
      } else if (!nombreParColonne.length) {
        nombreParColonne = [nombreParColonne];
      }

      var z;
      var n;
      var c;
      var rangee;
      var rangees = [];
      var champsIndexes = champs.filter(function (champ) {
        return (0, _utilitaires.estDefini)(champ.index) && !isNaN(Number(champ.index));
      });
      var champsNonIndexes = champs.filter(function (champ) {
        return !(0, _utilitaires.estDefini)(champ.index) || isNaN(Number(champ.index));
      });
      champsIndexes.sort(function (a, b) {
        var indexA = a.index;
        var indexB = b.index;
        return indexA > indexB ? 1 : indexA < indexB ? -1 : 0;
      });
      var toutLesChamps = champsIndexes.concat(champsNonIndexes);
      toutLesChamps.forEach(function (champ) {
        if (n === 0 || n === undefined) {
          z = z === undefined || ++z >= nombreParColonne.length ? 0 : z;
          n = nombreParColonne[z];
          c = n;

          if (rangee) {
            rangees.push(rangee);
          }

          rangee = [];
        }

        rangee.push(_this3.obtenirChamp(champ, c));
        n--;
      }, []);

      if (rangee && rangee.length) {
        rangees.push(rangee);
      }

      z = 0;
      return rangees.length ? rangees.map(function (rangee) {
        return /*#__PURE__*/_react.default.createElement("div", {
          key: "rangee-".concat(z++),
          className: "mfa-section-rangee"
        }, rangee);
      }) : null;
    }
  }, {
    key: "renderTitre",
    value: function renderTitre() {
      var _this4 = this;

      var titre = this.props.titre;

      if (this.props.cachable) {
        return /*#__PURE__*/_react.default.createElement("a", {
          className: "mfa-section-titre-cache",
          onClick: function onClick() {
            return _this4.setState({
              cache: !_this4.state.cache
            });
          }
        }, " ", /*#__PURE__*/_react.default.createElement(_semanticUiReact.Icon, {
          name: "caret ".concat(this.state.cache ? 'right' : 'down')
        }), titre);
      }

      return titre;
    }
  }, {
    key: "render",
    value: function render() {
      var afficherTitre = this.props.afficherTitre;
      this.champs = {};
      var ComposanteTitre = this.props.estSousSection === true ? 'h5' : 'h4';
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "mfa-section"
      }, !(0, _utilitaires.estDefini)(afficherTitre) || afficherTitre !== false ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(ComposanteTitre, null, this.renderTitre()), /*#__PURE__*/_react.default.createElement(_MfaSeparateur.MfaSeparateur, {
        espaceDessous: true
      })) : null, this.props.cache || this.props.cachable && this.state.cache ? null : this.renderCorps(), this.props.cache || this.props.cachable && this.state.cache ? null : /*#__PURE__*/_react.default.createElement("div", {
        className: "mfa-section-enfants"
      }, this.props.children));
    }
  }]);

  return MfaSection;
}(_react.Component);

exports.MfaSection = MfaSection;

_defineProperty(MfaSection, "dictionnaireChamp", void 0);